<template>
  <div>
    <div class="register absolute">
      <div class="bg-bg">
        <div class="shading">
          <div class="pictrue acea-row row-center-wrapper">
            <img :src="logoUrl" v-if="logoUrl" />

            <img src="@assets/images/logo2.png" v-else />
          </div>
          <div class="logo_name">
            <img src="../../assets/newImg/login_1.png" alt="" />
          </div>
        </div>
        <div class="bottom"></div>
        <div class="whiteBg">
          <div class="title acea-row row-center-wrapper">
            <div class="item">绑定手机号</div>
          </div>
          <div class="list">
            <div class="item">
              <div class="acea-row row-between-wrapper">
                <!-- <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg> -->
                <input
                  type="text"
                  placeholder="输入手机号码"
                  v-model="account"
                />
              </div>
            </div>
            <div class="item">
              <div class="align-left">
                <!-- <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg> -->
                <input
                  type="text"
                  placeholder="填写验证码"
                  class="codeIput"
                  v-model="captcha"
                />
                <button
                  class="code"
                  :disabled="disabled"
                  :class="disabled === true ? 'on' : ''"
                  @click="code"
                >
                  {{ text }}
                </button>
              </div>
            </div>
            <div class="item" v-if="isShowCode">
              <div class="align-left">
                <!-- <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg> -->
                <input
                  type="text"
                  placeholder="填写验证码"
                  class="codeIput"
                  v-model="codeVal"
                />
                <div class="code" @click="again">
                  <img :src="codeUrl" />
                </div>
              </div>
            </div>
          </div>
          <div class="logon" @click="bindMobile">立即绑定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import Vue from "vue";
import { Checkbox } from "vant";
Vue.use(Checkbox);
// Vue.use(Dialog);
import {
  login,
  bindPhone,
  registerVerify,
  register,
  getCodeApi,
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";

const BACK_URL = "login_back_url";

export default {
  name: "BindMobile",
  mixins: [sendVerifyCode],
  data: function () {
    return {
      userinfo: {},
      account: "",
      password: "",
      captcha: "",
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      checked: false,
      show: false,
    };
  },
  mounted: function () {
    if (this.$route.query && this.$route.query.userinfo) {
      this.userinfo = decodeURIComponent(this.$route.query.userinfo);
    }
    console.log("userinfo--->", this.userinfo);
    this.getCode();
    this.getLogoImage();
  },
  methods: {
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then((res) => {
          this.keyCode = res.data.key;
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      await registerVerify({
        phone: that.account,
        // type: that.type,
        key: that.keyCode,
        // code: that.codeVal
      })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch((res) => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then((res) => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async bindMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码")),
            ],
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      var data = {
        // userinfo: this.userinfo,
        captcha: captcha,
        phone: account,
        spread: localStorage.getItem("spread"),
      };
      bindPhone(data)
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("uid", res.data.result.uid);
            window.location.href = localStorage.getItem("historyRouter");
          } else {
            that.$dialog.error(res.msg);
          }
        })
        .catch((error) => {
          that.$dialog.error(error.msg);
        });
    },
  },
};
</script>

<style scoped>
.code img {
  width: 100%;
  height: 100%;
}
.logo_name img {
  width: 317px;
  margin: 24px 31px 0 21px;
  height: 59px;
}
.register .bottom {
  margin-top: 88px;
  width: 6.1rem;
}
.bg-bg {
  background: url("../../assets/newImg/login_bg.png") no-repeat;
  background-size: 100% 100%;
  height: 424px;
}
.register .whiteBg {
  margin-top: 0;
  width: 90%;
  height: 310px;
  box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
}
.register {
  background: #ffffff;
}
.register .whiteBg .logon {
  width: 225px;
  height: 50px;
  line-height: 50px;
  border-radius: 100px;
  background: #d01112;
  margin: 54px auto auto auto;
}
.register .whiteBg .list {
  margin-top: 40px;
}
.register .whiteBg .list .item {
  background: #faf7f7;
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
  padding: 0;
  display: flex;
  align-items: center;
  border-bottom: 0;
  margin-bottom: 20px;
}
.register .whiteBg .list .item input {
  padding-left: 20px;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #faf7f7 inset;
}
.register .whiteBg .title {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 42px;
  color: #d01112;
}
.register .whiteBg .title .item ~ .item {
  margin-left: 0;
}
.register .whiteBg .tip {
  text-align: right;
}
.agree {
  width: 100%;
  /* position: absolute;
  bottom: 10px;
  left: 0;
  right: 0; */
  text-align: center;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4.6rem;
}
.register .shading .pictrue {
  background: none;
}
.under-line {
  text-decoration: underline;
}
.register .whiteBg .list .item .code {
  right: 20px;
}
</style>
